__webpack_require__.p = "/rest-countries/";